export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "nl-NL": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wachtwoord opnieuw instellen"])},
        "placeholders": {
          "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailadres..."])}
        },
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset wachtwoord"])},
        "error": {
          "nousername": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vul uw e-mailadres in"])},
          "tooManyRequests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Er is al een wachtwoord reset aangevraagd, controleer uw e-mail spam box of probeer het later opnieuw"])},
          "unknown": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout tijdens resetten, probeer het later opnieuw"])}
        }
      },
      "nl-BE": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wachtwoord opnieuw instellen"])},
        "placeholders": {
          "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailadres..."])}
        },
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset wachtwoord"])},
        "error": {
          "nousername": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vul uw e-mailadres in"])},
          "tooManyRequests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Er is al een wachtwoord reset aangevraagd, controleer uw e-mail spam box of probeer het later opnieuw"])},
          "unknown": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fout tijdens resetten, probeer het later opnieuw"])}
        }
      },
      "fr-BE": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réinitialiser le mot de passe"])},
        "placeholders": {
          "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email..."])}
        },
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réinitialiser le mot de passe"])},
        "error": {
          "nousername": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez votre adresse email"])},
          "tooManyRequests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une réinitialisation du mot de passe a déjà été demandée, veuillez réessayer plus tard"])},
          "unknown": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite lors de la demande de modification de votre mot de passe"])}
        }
      },
      "fr-FR": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réinitialiser le mot de passe"])},
        "placeholders": {
          "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email..."])}
        },
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Réinitialiser le mot de passe"])},
        "error": {
          "nousername": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entrez votre adresse email"])},
          "tooManyRequests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une réinitialisation du mot de passe a déjà été demandée, veuillez réessayer plus tard"])},
          "unknown": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Une erreur s'est produite lors de la demande de modification de votre mot de passe"])}
        }
      },
      "de-DE": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passwort neu einrichten"])},
        "placeholders": {
          "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-Mail-Adresse ..."])}
        },
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Passwort zurücksetzen"])},
        "error": {
          "nousername": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geben Sie Ihre E-Mail-Adresse ein"])},
          "tooManyRequests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Das Zurücksetzen des Passworts wurde bereits angefordert. Bitte überprüfen Sie den Spam-Ordner Ihres E-Mail-Postfachs oder versuchen Sie es später noch einmal."])},
          "unknown": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fehler beim Zurücksetzen, versuchen Sie es bitte später noch einmal"])}
        }
      },
      "en-GB": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset password"])},
        "placeholders": {
          "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Email address..."])}
        },
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset password"])},
        "error": {
          "nousername": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Enter your email address"])},
          "tooManyRequests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["A password reset has already been requested, please check your email spam folder or try again later"])},
          "unknown": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Error during reset, try again later"])}
        }
      },
      "da-DK": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nulstil adgangskode"])},
        "placeholders": {
          "username": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["E-mailadresse..."])}
        },
        "submit": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nulstil adgangskode"])},
        "error": {
          "nousername": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Indtast din e-mailadresse"])},
          "tooManyRequests": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Der er allerede anmodet om nulstilling af adgangskode, tjek venligst din spammappe, eller prøv igen senere"])},
          "unknown": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejl under nulstilling, prøv igen senere"])}
        }
      }
    }
  })
}